import axios from "axios";
import Vue from "vue";
import router from "../router";


// 创建axios实例
const service = axios.create({
  baseURL: process.env.BASE_URL,
  timeout: 10000, // 请求超时时间(因为需要调试后台,所以设置得比较大)
  headers: {
    // 1 默认的格式请求体中的数据会以json字符串的形式发送到后端  'Content-Type: application/json '
    // 2 请求体中的数据会以普通表单形式（键值对）发送到后端 'Content-Type: application/x-www-form-urlencoded'
    // 3 它会将请求体的数据处理为一条消息，以标签为单元，用分隔符分开。既可以上传键值对，也可以上传文件 'Content-Type: multipart/form-data'
    // 'Content-Type': 'application/json'
  },
});

// loading框设置局部刷新，且所有请求完成后关闭loading框
let loading;

function startLoading() {
  loading = Vue.prototype.$loading({
    // lock: true, // true会导致滚动条消失
    text: "加载中...",
    background: "rgba(0, 0, 0, 0.7)",
  });
}
function endLoading() {
  loading.close();
}
//声明一个对象用于存储请求个数,只有第一个请求开loading，和最后一个请求关loading
let needLoadingRequestCount = 0;
function showLoading() {
  if (needLoadingRequestCount === 0) {
    startLoading();
  }
  needLoadingRequestCount++;
}
function hideLoading() {
  if (needLoadingRequestCount <= 0) return;
  needLoadingRequestCount--;
  if (needLoadingRequestCount === 0) {
    endLoading();
  }
}

function addHeader(tokenKey,config) {
  addHeader(tokenKey,tokenKey,config)
}
function addHeader(tokenKey,headerKey,config) {
  let val = window.localStorage.getItem(tokenKey)
  if (val == null || val == undefined) {
    return config
  }
  let index = val.indexOf("#");
  if (index > 0) {
    val = val.substring(0, index)
  }
  //添加到表头
  config.headers[headerKey] = val
  return config
}

// request拦截器
service.interceptors.request.use(
  (config) => {
    showLoading();
    config = addHeader("token","Authorization",config);
    // config = addHeader("appKey",config);
    let locale = localStorage.getItem("language")
    let localeObj = {
      'en_US': 'en_EN',
      'zh_CN': 'zh_CN',
      'zh_HK': 'zh_TW',
    }
    config.headers['Language'] = localeObj[locale]
    return config;
  },
  (error) => {
    hideLoading();
    Promise.reject(error);
  }
);
// response 拦截器
service.interceptors.response.use(
  (response) => {
    hideLoading();
    const res = response.data;
    // 接口返回的res.status == 200才算是正确返回，否则算接口报错
    console.log("接口返回数据:", res)
    if (res.code == 401) {
      //转到授权登录页
      localStorage.removeItem("token");
      // window.location.href = "/login";
      router.push("/login")
      return res;
    }
    return res;
  },
  (error) => {
    hideLoading();
    let message =  "未知错误";
    console.log("error=>",error)
    return Promise.reject(error);
  }
);

export default service;



// WEBPACK FOOTER //
// ./src/utils/request.js